export function getYoutubeId(url: string): string | null {
  const urlAfterSplit = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);

  return undefined !== urlAfterSplit[2] ? urlAfterSplit[2].split(/[^0-9a-z_-]/i)[0] : null;
}

export function getVimeoId(url: string): string | null {
  const matches = /(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/.exec(url);
  return matches !== null && matches[3] ? matches[3] : null;
}

export function getYoutubeThumbnail(url: string): string {
  return `https://img.youtube.com/vi/${getYoutubeId(url)}/hqdefault.jpg`;
}
